export function ChronologyEmptyStateIllustration() {
  return (
    <div className="mb-6 flex h-24 w-xs items-center justify-center">
      <div className="flex h-full flex-col items-center">
        <div className="w-0.5 grow bg-gray-200 mask-t-from-10%"></div>
        <div className="size-3.5 rounded-full border-2 border-gray-300 bg-gray-50"></div>
        <div className="w-0.5 grow bg-gray-200 mask-b-from-10%"></div>
      </div>

      <div className="mx-5 mr-8 h-15 grow rounded-lg border bg-gray-50 p-2 shadow-lg/3">
        <div className="mb-1.5 h-3 w-12 rounded-sm bg-gray-200/80"></div>
        <div className="mb-1 h-2.5 w-full rounded-sm bg-gray-200/50"></div>
        <div className="h-2.5 w-3/4 rounded-sm bg-gray-200/50"></div>
      </div>
    </div>
  );
}
